/** 分时预约 */

export default [{
  path: '/appointment/home',
  meta: {
    title: '景区预约'
  },
  component: () =>
    import ('../../pages/appointment/views/home'),
    children: [
      {
        path: '/appointment/home',
        redirect: '/appointment/home/statistics'
      },
      {
        path: 'statistics',
        component: () =>
            import ('../../pages/appointment/views/home/statistics/index.vue'),
        meta: {
            title: '景区预约'
        }
      },
      {
        path: 'distribution',
        component: () =>
            import ('../../pages/appointment/views/home/distribution/index.vue'),
        meta: {
            title: '景区预约'
        }
      },
      {
        path: 'list',
        component: () =>
            import ('../../pages/appointment/views/home/list/index.vue'),
        meta: {
            title: '景区预约'
        }
      }
    ]
},
{
  path: '/appointment/home/scenicDetele',
  name: 'scenicDetele',
  meta: {
    title: '入园预约单详情'
  },
  component: () =>
    import ('../../pages/appointment/views/home/scenicDetele')
},
{
  path: '/appointment/home/search',
  meta: {
    title: '搜索'
  },
  component: () =>
    import ('../../pages/appointment/views/home/search')
},
{
  path: '/appointment/home/select',
  meta: {
    title: '搜索'
  },
  component: () =>
    import ('../../pages/appointment/views/home/select')
},
]
